import { render, staticRenderFns } from "./replenishmentRegistration.vue?vue&type=template&id=b9d2f6fa&scoped=true&"
import script from "./replenishmentRegistration.vue?vue&type=script&lang=js&"
export * from "./replenishmentRegistration.vue?vue&type=script&lang=js&"
import style0 from "./replenishmentRegistration.vue?vue&type=style&index=0&id=b9d2f6fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d2f6fa",
  null
  
)

export default component.exports